"use strict";

import $ from "jquery";
import $hub from "../../shared/hub";
import scrollToElm from "../../Shared/helpers/helper.scrollToElm";

/**
 * Simply toggles parameter show/hide
 * @return {[undefined]}       [nothing returned]
 */

const elemsToggledThisLoop = [];
function alreadyToggled(elem) {
    // -------------------------
    // Author: Pelle Jensen
    // This function is simply a hacky attempt to solve an issue with the expand/collapse functionality.
    // The issue being solved is for CTA's with forms.
    // The "togglerButtons.each()" is being called twice for those CTA's, once adding and once removing the active class.
    // I'm assuming that there's a reason for this functionality... somewhere, so rather than risking re-introducing an old error
    // this hack, makes sure that no element will have the active class added and removed by the same click-event.
    // -------------------------
    let elemToggled = false;
    const curElem = elem[0];

    for (let i = 0; i < elemsToggledThisLoop.length; i++) {
        if (elemsToggledThisLoop[i] === curElem) {
            elemToggled = true;
        }
    }

    if (!elemToggled) {
        elemsToggledThisLoop.push(curElem);
    }

    return elemToggled;
}

export default function toggler() {
    /* accordion data-parameters
     * @param  {[number]} speed    [speed in ms]
     * @param  {[string]} object    [selector of toggled element]
     * @param  {[animation]} object    [toggling animation]
     */
    const TOGGLER = ".js-toggler";
    const NEWS_TOGGLER = ".js-news-toggler";
    const ANIMATIONS = {
        fade: $.fn.fadeToggle,
        slide: $.fn.slideToggle,
    };

    $(TOGGLER).each(function () {
        const $toggler = $(this);
        const $obj = $($toggler.data("togglerObj"));
        const speed = $toggler.data("togglerSpeed") || 500;
        const scroll = $toggler.data("togglerScroll") || false;
        const animation =
            ANIMATIONS[$toggler.data("togglerAnimation")] || $.fn.toggle;
        const $arrow = $toggler.find(".arrow-down");

        const toggleClassObj = $toggler.data("togglerClassObj");

        const options = {
            duration: speed,
        };

        $toggler.on("click", function (e) {
            e.preventDefault();
            elemsToggledThisLoop.length = 0;

            const $togglerArrow = $(this).find('[class*="arrow"]');

            if ($togglerArrow) {
                if ($togglerArrow.hasClass("arrow-down")) {
                    $togglerArrow
                        .removeClass("arrow-down")
                        .addClass("arrow-up");
                } else {
                    $togglerArrow
                        .removeClass("arrow-up")
                        .addClass("arrow-down");
                }
            }

            $(this).find(".btn-cta__text").toggle();
            $(this).find(".btn-cta__text--opposite").toggle();

            if (toggleClassObj) $obj.toggleClass(toggleClassObj);

            animation.call($obj, options);

            if (!$(this).hasClass("js-toggle--active") && scroll) {
                scrollToElm($obj, speed, 150);
            }

            const clickButton = $(this);
            const togglerButtons = $(this)
                .parents(".section")
                .find("[data-toggler-obj]");

            togglerButtons.each(function () {
                if (
                    $(this).data().togglerObj ===
                    `[data-toggler-id=${$obj.data().togglerId}]`
                ) {
                    if (!alreadyToggled($(this))) {
                        $(this).toggleClass("js-toggle--active");
                    }
                } else {
                    if (!alreadyToggled(clickButton)) {
                        clickButton.toggleClass("js-toggle--active");
                    }
                }
            });

            $arrow.toggleClass("arrow-down").toggleClass("arrow-up");

            // broadcast the change event
            setTimeout(() => {
                $hub.trigger("toggle.change");
                $toggler.blur();
            }, speed);
        });
    });

    $(NEWS_TOGGLER).each(function () {
        const $toggler = $(this);
        const speed = $toggler.data("togglerSpeed") || 500;

        const options = {
            duration: speed,
        };

        $toggler.on("click", function (e) {
            e.preventDefault();
            elemsToggledThisLoop.length = 0;

            const $obj = $($toggler.data("togglerObj")).slice(0, 6);

            if ($obj.length) {
                $.fn.slideDown.call($obj, options);
                $obj.removeClass("u-collapsed");
                $obj.each(function () {
                    const currentItem = $(this);
                    const newsImage = currentItem.find(".news__item-image");
                    const newsImageSrc = newsImage.data("src");

                    if (newsImageSrc) {
                        newsImage.css(
                            "background-image",
                            "url(" + newsImageSrc + ")",
                        );
                    }
                });
            }

            if (!$($toggler.data("togglerObj")).length) {
                $toggler.hide();
            }

            // broadcast the change event
            setTimeout(() => $hub.trigger("toggle.change"), speed);
        });
    });
}
